const facebookAppId = '3940328152867361'
const redirectUri = encodeURIComponent(window.location.origin + '/connect-facebook-lens/success')
const scope = 'public_profile,email,ads_read,business_management,pages_show_list,attribution_read,pages_read_engagement,pages_read_user_content'

// Some random value for now, might need to store in session if we change to a redirect flow
const state = encodeURIComponent(crypto.randomUUID())

const facebookAuthUrl = `https://www.facebook.com/v23.0/dialog/oauth?client_id=${facebookAppId}&display=popup&redirect_uri=${redirectUri}&state=${state}&scope=${scope}&response_type=code`

export default facebookAuthUrl